export default __webpack_public_path__ + "static/woori_tech_investment-520f13ee83675f640b237eb6cd38c078.jpg";